var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 16.6663C9.54036 16.6663 9.148 16.5031 8.82161 16.1768C8.49523 15.8504 8.33203 15.458 8.33203 14.9997C8.33203 14.5413 8.49523 14.149 8.82161 13.8226C9.148 13.4962 9.54036 13.333 9.9987 13.333C10.457 13.333 10.8494 13.4962 11.1758 13.8226C11.5022 14.149 11.6654 14.5413 11.6654 14.9997C11.6654 15.458 11.5022 15.8504 11.1758 16.1768C10.8494 16.5031 10.457 16.6663 9.9987 16.6663ZM9.9987 11.6663C9.54036 11.6663 9.148 11.5031 8.82161 11.1768C8.49523 10.8504 8.33203 10.458 8.33203 9.99967C8.33203 9.54134 8.49523 9.14898 8.82161 8.82259C9.148 8.4962 9.54036 8.33301 9.9987 8.33301C10.457 8.33301 10.8494 8.4962 11.1758 8.82259C11.5022 9.14898 11.6654 9.54134 11.6654 9.99967C11.6654 10.458 11.5022 10.8504 11.1758 11.1768C10.8494 11.5031 10.457 11.6663 9.9987 11.6663ZM9.9987 6.66634C9.54036 6.66634 9.148 6.50315 8.82161 6.17676C8.49523 5.85037 8.33203 5.45801 8.33203 4.99967C8.33203 4.54134 8.49523 4.14898 8.82161 3.82259C9.148 3.4962 9.54036 3.33301 9.9987 3.33301C10.457 3.33301 10.8494 3.4962 11.1758 3.82259C11.5022 4.14898 11.6654 4.54134 11.6654 4.99967C11.6654 5.45801 11.5022 5.85037 11.1758 6.17676C10.8494 6.50315 10.457 6.66634 9.9987 6.66634Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotIcon);
export default __webpack_public_path__ + "static/media/threedot-icon.d2eaf7d614a0f35617dfca3df8686464.svg";
export { ForwardRef as ReactComponent };